import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Features from '../../components/layouts/Features';
import time from '../../images/undraw_time_management_30iu.svg';
import share from '../../images/undraw_share_766i.svg';
import chat from '../../images/undraw_Group_chat_unwm.svg';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = Features;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h2>{`Get your team to communicate faster`}</h2>
    <img src={chat} />
    <p>{`Give your team the right tools and watch them proactively document their work and improve cross-teams communication.`}</p>
    <p>{`Diagrams are the common language that both your developers and products understand.`}</p>
    <h2>{`Accelerate onboardings`}</h2>
    <img src={time} />
    <p>{`Get your newcomers up and ready faster. With visual explanations in your onboarding process your new requites will learn and integrate concepts much faster.`}</p>
    <h2>{`Reduce bus-factor`}</h2>
    <img src={share} />
    <p>{`Enabling your team to write down information in way that feels natural and not constraint by a tool will change their habits.`}</p>
    <p>{`The more people will share information, the more flexible your team becomes!`}</p>


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      